import { render, staticRenderFns } from "./ItemMajor.vue?vue&type=template&id=4b2bf3c7&scoped=true&"
import script from "./ItemMajor.vue?vue&type=script&lang=ts&"
export * from "./ItemMajor.vue?vue&type=script&lang=ts&"
import style0 from "./ItemMajor.vue?vue&type=style&index=0&id=4b2bf3c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2bf3c7",
  null
  
)

export default component.exports